module.exports = __webpack_public_path__ + "static/scale-model-of-nsu-art-museum-fort-lauderdale-in-hollywood-florida-bdec696199da54ea8141322cf6699eaf.png";